import React from 'react';
import PropTypes from 'prop-types';
import {Wrapper} from '../';

const ErrorPage = ({message}) => (
  <Wrapper>
    <div className="error-page">
      <h1 className="error-page__heading">{message}</h1>
    </div>
  </Wrapper>
);

ErrorPage.propTypes = {
  message: PropTypes.string,
};

ErrorPage.defaultProps = {
  message: 'Page not found.',
};

export default ErrorPage;
